module.exports = __webpack_public_path__ + "static/media/objectives.df73e344.png";